import {Button, Form, Input, Checkbox, Space, Divider} from "antd";
import React, { useState, useEffect } from "react";
import type { CheckboxChangeEvent } from 'antd/es/checkbox'
// Note: This deep import still works in antd 5, but can be replaced with:
// import type { CheckboxProps } from 'antd';
// type CheckboxChangeEvent = Parameters<NonNullable<CheckboxProps['onChange']>>[0];
import { Cron } from 'react-js-cron'
import 'react-js-cron/dist/styles.css'

import cronstrue from 'cronstrue';
import {usePermissions} from "react-admin";

const CrontabForm = (props: any) => {
    const { permissions } = usePermissions();
    const { form, namePrefix = [], disabled = false } = props
    const isDisabled = disabled || permissions !== "ADMIN";
    const [cronText, setCronText] = useState<string>("* * * * *");
    const [enableCrontab, setEnableCrontab] = useState(false);

    const fieldName = (name: string) => [...namePrefix, name];

    const getField = (name: string) => form.getFieldValue(fieldName(name));
    const setField = (name: string, value: any) => form.setFieldValue(fieldName(name), value);

    useEffect(() => {
        // Set initial value for schedule_enabled
        const initialScheduleEnabled = getField("schedule_enabled")
        const initialScheduleCrontab = getField("schedule_crontab")
        if(initialScheduleEnabled)
            setEnableCrontab(initialScheduleEnabled)
        if(initialScheduleCrontab)
            setCronText(initialScheduleCrontab)
    }, []);

    useEffect (() => {
        // To sync enableCrontab and schedule_enabled in the form
        setField("schedule_enabled", enableCrontab)

        if(!enableCrontab)
            setField("schedule_crontab", null)
        else
            setField("schedule_crontab", cronText)

    }, [enableCrontab]);

    const parseCronText = (text: string) => {
        try { return <>Final: {cronstrue.toString(text, { locale: "en" })}</> }
        catch (e) { return <>Wrong crontab</> }
    }
    const onChange = (e: CheckboxChangeEvent) => {
        setEnableCrontab(e.target.checked);
    };

    useEffect(() => {
        // if cron text is changed, its value in the form should also be changed
        setField("schedule_crontab", cronText)
    }, [cronText]);

  return (
    <>
      <Form.Item label="Enable Crontab" name={fieldName("schedule_enabled")}>
          <Checkbox value={enableCrontab} checked={enableCrontab} onChange={onChange} disabled={isDisabled} />
      </Form.Item>
      <Form.Item
        hidden={!enableCrontab}
        label="Schedule Crontab"
        extra={parseCronText(cronText)}
        name={fieldName("schedule_crontab")}
        rules={[
          {
            validator: async (_, value) => {
              if (!enableCrontab) return;
              try {
                cronstrue.toString(value);
              } catch (e) {
                return Promise.reject(new Error('Invalid Cron Expression'));
              }
            },
          },
        ]}
      >
          <Input value={cronText} onChange={(e) => setCronText(e.target.value)} placeholder="* * * * *" disabled={isDisabled}/>
      </Form.Item>
      <Form.Item hidden={!enableCrontab} label="Crontab generator">
          <Cron value={cronText} setValue={setCronText} clearButton={false} disabled={isDisabled}/>
      </Form.Item>
    </>
  )
}

export default CrontabForm;